import cloneDeep from 'lodash/cloneDeep.js';

import CourseSettings from '@/models/CourseSettings.js';

/**
 * Narrow course-settings PUT payload for date-only Apply actions.
 *
 * @param {{ start_date?: unknown, end_date?: unknown }} settings
 */
export function courseDatePayload(settings) {
    return {
        start_date: settings.start_date,
        end_date: settings.end_date,
    };
}

/**
 * Sync a course-settings API response into Vuex-ORM and the course editor form.
 *
 * @param {Function} commit
 * @param {object | null | undefined} courseSettings
 * @param {{ formCommitRoot?: boolean }} [options]
 */
export function persistAppliedCourseSettings(commit, courseSettings, { formCommitRoot = false } = {}) {
    if (!courseSettings) {
        return;
    }

    const clonedCourse = cloneDeep(courseSettings.course);
    const settings = { ...courseSettings };
    delete settings.course;

    if (clonedCourse?.id) {
        commit(
            `Courses/${clonedCourse.id}/EDIT`,
            {
                property: 'course_settings',
                value: settings,
            },
            { root: true }
        );

        commit(
            `Courses/${clonedCourse.id}/EDIT`,
            {
                property: 'is_accessible_to_students',
                value: clonedCourse.is_accessible_to_students,
            },
            { root: true }
        );

        commit(
            formCommitRoot ? 'CourseTemplateForm/updateCourseField' : 'updateCourseField',
            {
                field: 'course_settings',
                value: settings,
            },
            formCommitRoot ? { root: true } : undefined
        );
    }

    const row = CourseSettings.find(settings.id);
    if (row) {
        row.$update({
            start_date: settings.start_date,
            end_date: settings.end_date,
        });
    }
}
